import { useDispatch } from 'react-redux'

import { useNavigate } from 'react-router-dom'
import { actions } from 'builder/modules/panel'
import { DocumentTypes } from 'builder/modules/constants'
import { Service } from '../../../../types'

type ClCraftingActionsProps = {
  handleCreateCl: () => void
  handleCompletedClick: () => void
}

export const useClCraftingActions = (service: Service): ClCraftingActionsProps => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleCreateCl = () => {
    dispatch(actions.createDocument({ type: DocumentTypes.coverLetter }))
  }

  const handleCompletedClick = () => {
    navigate(service.getNextActionUrl())
  }

  return {
    handleCreateCl,
    handleCompletedClick,
  }
}
